import type { SVGAttributes } from 'react';

export function CatalanIcon(props: SVGAttributes<SVGSVGElement>) {
	return (
		<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<path
				d="M31.9 17.77c-.02.16-.04.32-.06.49-.01.06-.02.13-.03.2-.03.2-.07.4-.11.6l-.02.1v.01l-.01.06c-.16.74-.35 1.43-.59 2.1H.91c-.21-.61-.39-1.24-.54-1.88l-.02-.09-.02-.09c-.1-.49-.18-.99-.23-1.5H31.9v-.01Z"
				fill="#D91219"
			/>
			<path
				d="M31.09 21.33c-.33.93-.75 1.82-1.23 2.66-.18.31-.36.6-.56.89H2.69c-.19-.29-.38-.59-.55-.89-.49-.84-.9-1.74-1.23-2.66h30.18Z"
				fill="#FBDC1D"
			/>
			<path
				d="M29.3 24.89c-.26.38-.53.76-.81 1.11-.72.9-1.53 1.72-2.43 2.44H5.94c-.89-.73-1.71-1.54-2.43-2.44-.29-.36-.56-.73-.81-1.11H29.3Z"
				fill="#D91219"
			/>
			<path d="M26.06 28.44C23.31 30.67 19.81 32 16 32s-7.31-1.33-10.06-3.56h20.12Z" fill="#FBDC1D" />
			<path
				d="M29.3 7.11H2.7c.26-.38.52-.76.81-1.11C4.24 5.1 5.06 4.27 5.95 3.56h20.11c.9.72 1.71 1.54 2.44 2.44.28.36.55.72.8 1.11Z"
				fill="#D91219"
			/>
			<path d="M26.05 3.56H5.94C8.69 1.33 12.19 0 16 0s7.31 1.33 10.05 3.56Z" fill="#FBDC1D" />
			<path
				d="M31.09 10.67H.91c.33-.93.74-1.83 1.23-2.67.18-.3.36-.6.56-.89h26.61c.19.29.38.59.56.89.49.84.9 1.73 1.22 2.67Z"
				fill="#FBDC1D"
			/>
			<path
				d="M31.9 14.23H.1v-.04l.01-.04c.14-1.2.41-2.37.81-3.48h30.17c.2.55.36 1.12.5 1.69l.01.04.01.05c.08.37.15.74.21 1.11v.03l.01.04c.01.19.04.39.06.59Z"
				fill="#D91219"
			/>
			<path
				d="M32 16v.24l-.01.11v.05c-.02.46-.05.93-.09 1.38H.1c-.01-.1-.02-.19-.03-.28l-.01-.16c-.03-.31-.04-.62-.06-.94V16c0-.11 0-.22.01-.32v-.07c.01-.33.03-.66.06-.97v-.02l.01-.09.03-.18v-.1h31.8c.05.45.08.91.1 1.38v.04l-.01.06V16Z"
				fill="#FBDC1D"
			/>
		</svg>
	);
}
